
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

interface QuizOptionProps {
  id: string;
  text: string;
  selected: boolean;
  correct: boolean | null; // null when not revealed
  answered: boolean;
  onSelect: () => void;
}

const QuizOption = ({ 
  id, 
  text, 
  selected, 
  correct, 
  answered, 
  onSelect 
}: QuizOptionProps) => {
  // Determine styles based on selection and correctness
  let optionClasses = "relative flex items-center p-4 border rounded-lg cursor-pointer transition-all duration-300";
  
  if (!answered) {
    optionClasses += selected 
      ? " border-hero-mid bg-[#EBF2F9] shadow-md" 
      : " border-gray-200 hover:border-gray-300 hover:bg-gray-50";
  } else {
    if (selected) {
      optionClasses += correct 
        ? " border-green-500 bg-green-50" 
        : " border-red-500 bg-red-50";
    } else if (correct) {
      optionClasses += " border-green-500 bg-green-50";
    } else {
      optionClasses += " border-gray-200 opacity-70";
    }
    optionClasses += " cursor-default";
  }
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div 
        className={optionClasses}
        onClick={() => !answered && onSelect()}
        data-testid={`quiz-option-${id}`}
      >
        <div className="pr-8 flex-grow">
          <span className="text-base text-gray-700">{text}</span>
        </div>
        
        {answered && (
          <div className="absolute right-4">
            {correct && (
              <Check className="w-5 h-5 text-green-500" />
            )}
            {selected && !correct && (
              <X className="w-5 h-5 text-red-500" />
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default QuizOption;
